import {
  ClinicIncentivePeriodModel,
  IClinicIncentivePeriodModel,
} from '@common/models/ClinicIncentivePeriodModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class ClinicIncentivePeriodService {
  private static baseUrl: string = '/api/clinicincentiveperiod';
  static tags = {
    addClinicIncentivePeriod: 'addClinicIncentivePeriod',
    getClinicIncentivePeriods: 'getClinicIncentivePeriods',
  };

  static getClinicIncentivePeriods = (
    options?: ServiceMethodOptions,
  ): Promise<ClinicIncentivePeriodModel[]> => {
    return trackPromise(
      new Promise<ClinicIncentivePeriodModel[]>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .get<IClinicIncentivePeriodModel[]>()
          .then((response) => {
            ServiceHelper.showSuccess(
              'Clinic Incentive Period fetched',
              options,
            );
            resolve(response);
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to get Clinic Incentive Period.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.getClinicIncentivePeriods,
    );
  };

  static addClinicIncentivePeriod = (
    data: IClinicIncentivePeriodModel,
    options?: ServiceMethodOptions,
  ): Promise<ClinicIncentivePeriodModel> => {
    return trackPromise(
      new Promise<IClinicIncentivePeriodModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IClinicIncentivePeriodModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess(
              'Clinic Incentive Period updated.',
              options,
            );
            resolve(new ClinicIncentivePeriodModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to update Clinic Incentive Period.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.addClinicIncentivePeriod,
    );
  };
}
